import _ from 'lodash'

import DimensionMuncher from './dimensionMuncher'
import Dimensions from './dimensions'
import PointDimensions from './pointDimensions'

export default class Area extends DimensionMuncher {
  /**
   * call - This method returns the data structure to print a line chart
   *
   * @method
   */
  call() {
    const processedData = new Dimensions(
      this.data,
      this.axisNames(),
      this.dimensionGenerator()
    ).call()

    return {
      processedData,
      min: this.minValue(),
    }
  }

  /**
   * dimensionGenerator - This method returns a PointDimensions object that have a DimensionsGenerator that was
   * prevously configured in order to generate a data structure to print lines chart or area charts
   *
   * @method
   */
  dimensionGenerator() {
    return new PointDimensions(this.query.id, this.axisNames(), {}).call()
  }

  /**
   * minValue - Returns the minimum numeric value for the Y axis across data items.
   * @returns The minimum Y value, or undefined if data is empty.
   */
  private minValue(): number | undefined {
    const { yAxis } = this.axisNames()
    // Map items to numeric Y values and find the minimum
    const values = this.data.map((item) => item[yAxis] as number)
    return _.min(values)
  }
}
